import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { of } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import UIHelper from 'src/app/core/utility/ui-helper';
import Helper from 'src/app/core/utility/helper';
import { SubmittedProposalPartInfo } from 'src/app/models/internal/submitted-proposal-partinfo';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Constants } from 'src/app/core/constants';
import { QuerySubmittedProposalDTO } from 'src/app/models/internal/query-submittedproposal-dto';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import {SourceType} from 'src/app/models/sourcetype';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { NGXLogger } from 'ngx-logger';
import { ICanExportData } from 'src/app/core/interfaces/can-export-data.interface';
import { PackageType } from 'src/app/models/packagetype';
/**
 * TMS-17427 Add Submitted proposal view for suppliers
 */
@Component({
  selector: 'app-Submittedproposallist',
  templateUrl: './submitted-proposal-list.component.html',
  styleUrls: ['./submitted-proposal-list.component.scss']
})
export class SubmittedProposalListComponent extends BaseGridPage implements OnInit, AfterViewInit, ICanExportData {
  excelFilenamePrefix = 'SubmittedProposals_';
  pageSizes: number[] = [10, 25, 50];
  filterForm: FormGroup;
  partSubmittedProposalInfoList: SubmittedProposalPartInfo[];
  sourceTypeList: SourceType[];
  partSystemList: PartSystemDTO[];
  packageTypeList: PackageType[];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private proposalService: ProposalService,
    localstorageService: LocalstorageService,
    private toastService: ToastService,
    logger: NGXLogger
  ) { 
    super(localstorageService, logger, null);
    this.filterForm = this.fb.group({
        SourceTypeId: [null],
        PartNumber: [null],
      PartCategoryId: [null],
      PackageTypeId: [null]
    });
  }

  ngOnInit() {
    this.initFilterValues();
    this.getSourceTypes();
    this.getPartSystems();
    this.getPackageTypes();
    this.fillGrid();
  }

  fillGrid(): void {
    this.partSubmittedProposalInfoList = [];
    this.filter.Skip = this.skip;
    this.filter.Take = this.pageSize;
    const querySubmittedProposalDTO: QuerySubmittedProposalDTO = {
        SearchFilter: this.filter
    };
    this.getSubmittedProposals(querySubmittedProposalDTO);
  }

  updateFilter() {
    this.filter.SearchFilterConditions = [];
    this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
    this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
    this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartCategoryId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
    this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PackageTypeId');
  }

  clearFilter() {
      this.filterForm.reset();
      this.filter.SearchFilterConditions = [];
      this.search();
  }

  getSubmittedProposals(querySubmittedProposalDTO: QuerySubmittedProposalDTO) {
    this.updateFilter();
    this.dataService
        .getSubmittedProposals(querySubmittedProposalDTO)
        .subscribe((response: any) => {
            if (response != null) {
                this.partSubmittedProposalInfoList = response.Data;
                this.gridView = of({
                    data: response.Data,
                    total: response.Total ? response.Total : 0,
                });
            }
        });
  }

  getSourceTypes() {
    this.dataService.getParentSourceTypes().subscribe((response: any) => {
        if (response && response.Data != null) {
            this.sourceTypeList = response.Data;
        }
    });
  }

  getSourceType(dataItem) {
    if (dataItem.ParentSourceTypeId) {
        const source = this.sourceTypeList.find(x => x.Id == dataItem.ParentSourceTypeId);
        return UIHelper.supplierDisplayCell(source.Name, source.Description);
    } else {
        return UIHelper.supplierDisplayCell(dataItem.SourceTypeName, dataItem.SourceTypeDescription);
    }
  }

  getPartSystemName(id: number) {
      if (id != null) {
        return this.partSystemList.find(x => x.Id === id).Description;
      }
      return '';
  }

  getPartSystems() {
    this.dataService
        .getPartSystems()
        .subscribe((response: any) => {
            if (response != null && response.Success) {
                this.partSystemList = response.Data;
            }
        });
  }

  getPackageTypes() {
    this.dataService.getPackageTypes().subscribe((response: any) => {
      if (response && response.Data != null) {
        this.packageTypeList = response.Data;
      }
    });
  }

  formatDate(unformattedDate: Date) {
    return Helper.formatDate(unformattedDate);
  }


  viewProposal(id: number) {
    this.proposalService.RefreshproposalToViewId(id);
    window.open('viewproposal/' + id, '_blank');
  }

  exportData() {
    const filename = this.excelFilenamePrefix + Helper.formatDateTime(new Date()) + '.xlsx';
    const querySubmittedProposalDTO: QuerySubmittedProposalDTO = {
        SearchFilter: this.filter
    };
    this.updateFilter();
    this.dataService
        .getSubmittedProposalsExcel(querySubmittedProposalDTO)
        .subscribe((response: any) => {
        if (response != null && response.Success) {
            UIHelper.DownloadExcelFile(response.Data, filename);
        } else {
            this.toastService.error(
                'Could not export data'
            );
        }
    });
  }

  //TMS-19213 Get PackageTypeDescription to display on table 
  getPackageType(packageTypeId) {
    return Helper.getPackageTypeDescription(packageTypeId);
  }
}
